module.exports = __webpack_public_path__ + "static/img/11.16426e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/zh/11.png
// module id = DbKl
// module chunks = 0